import { useQuery } from '@apollo/client';

export const useCacheNetworkQuery = (query, options) => {
  const result = useQuery(query, {
    ...options,
    fetchPolicy: 'cache-and-network',
    context: {
      backgroundLoading: true
    }
  });

  return {
    ...result,
    loading: !result.data ? result.loading : false,
    backgroundLoading: result.loading
  };
};
